export default {
  ACTIVE: 'active',
  DISABLED: 'disabled',
};
